import { RouteObject } from 'react-router-dom';
import { publicRoutes } from './public.routes';
import { authRoutes } from './auth.routes';
import { dashboardRoutes } from './dashboard.routes';

export const routes: RouteObject[] = [...authRoutes, ...dashboardRoutes, ...publicRoutes];
